(() => {
  const panel = document.getElementById('MoFavorites');
  if (!panel) return;
  const key = 'mo-favorites-v1';
  const list = panel.querySelector('[data-mo-favorites-list]');
  const empty = panel.querySelector('[data-mo-favorites-empty]');
  const status = document.querySelector('[data-mo-favorites-status]');
  const toast = document.querySelector('[data-mo-favorites-toast]');
  const toastAction = toast.querySelector('[data-mo-favorites-toast-action]');
  let opener;
  let lastFavorite;
  let timer;
  const text = (key, title = '') => (panel.dataset[key] || '').replace('__PRODUCT__', title);
  const safeProduct = value => {
    if (!value || !/^\d+$/.test(String(value.id)) || !/^[a-z0-9-]+$/.test(value.handle || '')) return null;
    const url = new URL(value.url || '', location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return null;
    let image = '';
    if (value.image) {
      const candidate = new URL(value.image, location.origin);
      if (candidate.protocol === 'https:' && (candidate.origin === location.origin || candidate.hostname === 'cdn.shopify.com')) image = candidate.href;
    }
    return { id: String(value.id), handle: value.handle, title: String(value.title || value.handle).slice(0, 250), url: url.pathname + url.search, image };
  };
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(data)) return [];
      return [...new Map(data.slice(0, 100).map(value => {
        try { const item = safeProduct(value); return item ? [item.id, item] : [null, null]; } catch { return [null, null]; }
      })).values()].filter(Boolean);
    } catch { return []; }
  };
  let items = read();
  const dismissToast = () => { toast.hidden = true; status.textContent = ''; };
  const scheduleDismiss = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (!toast.contains(document.activeElement)) dismissToast();
    }, 6000);
  };
  const announce = (message, showAction = false) => {
    status.textContent = message;
    toastAction.hidden = !showAction || panel.open;
    toast.hidden = false;
    scheduleDismiss();
  };
  const update = (root = document) => {
    const buttons = [...root.querySelectorAll('[data-mo-favorite]')];
    if (root.matches?.('[data-mo-favorite]')) buttons.push(root);
    buttons.forEach(button => {
      const selected = items.some(item => item.id === button.dataset.productId);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', text(selected ? 'remove' : 'add', button.dataset.productTitle));
      button.hidden = false;
    });
    document.querySelectorAll('[data-mo-favorites-open]').forEach(button => {
      if (!button.matches('[data-mo-favorites-toast-action]')) button.hidden = false;
      button.setAttribute('aria-label', `${button.dataset.label} (${items.length})`);
    });
    document.querySelectorAll('[data-mo-favorites-count]').forEach(badge => {
      badge.textContent = String(items.length);
      badge.hidden = !items.length;
    });
  };
  const render = () => {
    list.replaceChildren();
    empty.hidden = items.length > 0;
    items.forEach(item => {
      const row = document.createElement('li');
      row.className = 'mo-favorites__item';
      const imageLink = document.createElement('a');
      imageLink.href = item.url;
      imageLink.tabIndex = -1;
      imageLink.setAttribute('aria-hidden', 'true');
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.width = 72;
        image.height = 92;
        image.loading = 'lazy';
        image.className = 'mo-favorites__image';
        imageLink.append(image);
      }
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      const hint = document.createElement('small');
      hint.textContent = text('view');
      link.append(hint);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'mo-favorites__remove';
      remove.dataset.moFavoritesRemove = item.id;
      remove.setAttribute('aria-label', text('remove', item.title));
      remove.textContent = '×';
      row.append(imageLink, link, remove);
      list.append(row);
    });
  };
  const save = (next, message, showAction = false) => {
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch { announce(text('error')); return false; }
    items = next;
    update();
    if (panel.open) render();
    announce(message, showAction);
    return true;
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('button, [data-mo-favorites-open]');
    if (!target) return;
    if (target.matches('[data-mo-favorite]')) {
      event.preventDefault();
      lastFavorite = target;
      const id = target.dataset.productId;
      if (items.some(item => item.id === id)) save(items.filter(item => item.id !== id), text('removed'));
      else {
        if (items.length >= 100) { announce(text('limit')); return; }
        const item = safeProduct({ id, handle: target.dataset.productHandle, title: target.dataset.productTitle, url: target.dataset.productUrl, image: target.dataset.productImage });
        if (item) save([...items, item], text('saved'), true);
      }
    } else if (target.matches('[data-mo-favorites-open]')) {
      event.preventDefault();
      const drawer = target.closest('header-drawer');
      const summary = drawer?.querySelector('summary');
      const cartDrawer = target.closest('cart-drawer');
      opener = cartDrawer ? document.getElementById('cart-icon-bubble') : summary || (target === toastAction ? lastFavorite : target);
      if (drawer) drawer.closeMenuDrawer(event, summary);
      if (cartDrawer) cartDrawer.close();
      dismissToast();
      render();
      if (!panel.open) panel.showModal();
      document.body.classList.add('mo-favorites-visible');
    } else if (target.matches('[data-mo-cart-open]')) {
      event.preventDefault();
      panel.close();
      const cartDrawer = document.querySelector('cart-drawer');
      cartDrawer?.open(document.getElementById('cart-icon-bubble'));
    } else if (target.matches('[data-mo-favorites-close]')) panel.close();
    else if (target.matches('[data-mo-favorites-remove]')) {
      const index = items.findIndex(item => item.id === target.dataset.moFavoritesRemove);
      if (save(items.filter(item => item.id !== target.dataset.moFavoritesRemove), text('removed'))) {
        const next = list.querySelectorAll('[data-mo-favorites-remove]');
        (next[Math.min(index, next.length - 1)] || panel.querySelector('[data-mo-favorites-close]')).focus();
      }
    }
  });
  panel.addEventListener('close', () => {
    document.body.classList.remove('mo-favorites-visible');
    if (opener?.isConnected) opener.focus();
  });
  document.addEventListener('keydown', event => {
    if (event.code === 'Space' && event.target.matches('a[data-mo-favorites-open]')) {
      event.preventDefault();
      event.target.click();
    }
  });
  toast.addEventListener('mouseenter', () => clearTimeout(timer));
  toast.addEventListener('mouseleave', scheduleDismiss);
  toast.addEventListener('focusin', () => clearTimeout(timer));
  toast.addEventListener('focusout', scheduleDismiss);
  panel.addEventListener('click', event => {
    if (event.target !== panel) return;
    const rect = panel.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close();
  });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    items = read();
    update();
    if (panel.open) render();
  });
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.matches('[data-mo-favorite], [data-mo-favorites-open]') || node.querySelector('[data-mo-favorite], [data-mo-favorites-open]'))) update(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
  update();
})();


